import { FileDropZoneModal } from '@payaca/ambrosia';
import { requestPersistUploadAndLinkToEntity } from '@payaca/store/uploads/uploadsActions';
import {
  MAX_UPLOAD_FILE_SIZE_BYTES,
  acceptedFilesForCategories,
} from '@payaca/uploads';
import { FC, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

const acceptedFiles = acceptedFilesForCategories([
  'image',
  'document',
  'video',
]);

interface Props {
  scheduledEventId: number;
  isOpen: boolean;
  onClose: () => void;
  onUploadSuccess: () => void;
}

export const ScheduledEventFileUploadModal: FC<Props> = ({
  scheduledEventId,
  isOpen,
  onClose,
  onUploadSuccess,
}) => {
  const dispatch = useDispatch();

  const [showUploadError, setShowUploadError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  const onUploadFile = useCallback(
    async (files: File[]) => {
      setShowUploadError(false);
      setIsLoading(true);

      const uploadedFilePromises = await Promise.allSettled(
        files.map(
          (file) =>
            new Promise<void>((resolve, reject) => {
              dispatch(
                requestPersistUploadAndLinkToEntity(
                  {
                    file,
                    fileName: file.name,
                    entityId: scheduledEventId,
                    entityType: 'scheduledEvent',
                  },
                  (error) => {
                    if (error) {
                      reject();
                    } else {
                      resolve();
                    }
                  }
                )
              );
            })
        )
      );

      if (uploadedFilePromises.find((p) => p.status === 'rejected')) {
        setShowUploadError(true);
      }

      if (uploadedFilePromises.find((p) => p.status === 'fulfilled')) {
        onUploadSuccess();
      }

      setIsLoading(false);
    },
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useCallback has missing dependencies: 'scheduledEventId', and 'dispatch'
    [onUploadSuccess]
  );

  return (
    <FileDropZoneModal
      isLoading={isLoading}
      hasError={showUploadError}
      isOpen={isOpen}
      onClose={onClose}
      accepts={acceptedFiles}
      dropzoneOptions={{
        // oxlint-disable-next-line typescript/no-misused-promises -- FIXME: pre-existing error: Promise-returning function provided to property where a void return was expected.
        onDrop: onUploadFile,
        maxSize: MAX_UPLOAD_FILE_SIZE_BYTES,
      }}
    />
  );
};
